<template>
  <div class="app_wrapper">
    <nav-header ref="navHeader" class="app_header" />
    <el-scrollbar class="app_main" ref="appMain">
      <app-main />
    </el-scrollbar>
    <ys-aside-right v-if="$route.path!='/about'"></ys-aside-right>
    <announcement-notice ref="announcementNotice"></announcement-notice>
    <ys-register-popup rf="ysRegisterPopup"></ys-register-popup>
  </div>
</template>

<script>
  import {
    NavHeader,
    AppMain
  } from './components'
  import ysAsideRight from '@/components/ys-aside-right.vue'
  import ysRegisterPopup from '@/components/ys-register-popup.vue'
  import announcementNotice from '@/components/announcement-notice.vue'
  import {
    sendMsg,
    listenMsg
  } from '@/utils/crossTagMsg'

  import {
    mapActions,
  } from 'vuex'
  import {
    getGoodsTag
  } from '@/api/common'
  export default {
    name: 'layout',
    components: {
      NavHeader,
      AppMain,
      ysAsideRight,
      announcementNotice,
      ysRegisterPopup
    },
    data() {
      return {

      }
    },
    watch: {
      $route() {
        this.addTags()
      }
    },
    mounted() {
      this.$bus.$on('scrollTop', () => {
        this.$refs.appMain.wrap.scrollTop = 0
      })
      this.addTags()
      this.getUserInfo()

      listenMsg(this.initStore)
      this.getTagsList();
      //下拉加载
      this.$refs.appMain.wrap.addEventListener("scroll", (e)=>{
        let poor  = e.target.scrollHeight - e.target.clientHeight
        let drop  = parseInt(e.target.scrollTop)+600;
        if(this.$route.path=="/selection" && poor <= drop && drop-poor<200){
            this.$bus.$emit('goodsDownLoad')
        }
        this.$refs.navHeader.onSetHeight(e.target.scrollTop);
      },true)
    },
    methods: {
      ...mapActions(['getUserInfo', 'setState']),
      /**
       * 添加标签
       * */
      addTags() {
        const {
          name
        } = this.$route
        if (name) {
          this.$store.dispatch('tagsView/addView', this.$route)
        }
        return false
      },
      /**
       * 监听localStorage回调
       * 更新对应数据
       * */
      initStore(key, data) {
        if (!key || !data) {
          return
        }
        switch (key) {
          case 'userInfo':
            this.setState({
              userInfo: data.payload,
              userInfoTime: data.temp
            })
            break;
          default:
            if(data.from === 'NavHeader'){
              this.$refs.navHeader.initSave({
                key,
                params: data.payload
              });
            }
        }
      },
      /**
       * @获取自定义标签
       */
      getTagsList(){
        getGoodsTag().then(res=>{
          this.$store.commit('SET_STATE', {
              goodsTags: res.result
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app {
    &_wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      min-width: 1060px;
    }

    &_header {
      flex-shrink: 0;
      position: relative;
      z-index: 30;
    }

    &_main {
      flex: 1 0 0;

      /* 设置滚动条的样式 */
      &::-webkit-scrollbar {
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      // /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        width: 6px;
        border-radius: 12px;
        background: rgba(0, 0, 0, 0.2);
      }

      ::v-deep {
        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .el-scrollbar__bar.is-vertical {
          width: 12px;
        }

        .el-scrollbar__thumb {
          background-color: rgba(144, 147, 153, .6);
        }
      }
    }
  }
</style>
